import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TableModule } from '@openng/optimus-ui/table';
import { CommonModule } from '@angular/common';
import { ResponsysService } from '../../services/responsys.service';
import { AuditLog } from '../../models/audit-log/audit-log.interface';
import { ButtonModule } from '@openng/optimus-ui/button';
import { Subject, takeUntil } from 'rxjs';
import { ToastBarService } from '../../services/toast-bar.service';

@Component({
    selector: 'app-audit-log-table',
    imports: [TableModule, CommonModule, ButtonModule],
    providers: [ResponsysService],
    templateUrl: './audit-log-table.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './audit-log-table.component.scss'
})
export class AuditLogTableComponent implements OnInit, OnDestroy {
  auditLogs!: AuditLog[];
  private _destroy$ = new Subject<void>();
  loading: Boolean = true;

  constructor(
    private responsysService: ResponsysService,
    private toastBarService: ToastBarService
  ) {}
  ngOnDestroy(): void {
    this._destroy$.complete();
  }

  ngOnInit(): void {
    this.responsysService
      .getAllAuditLogs()
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (res) => {
          this.auditLogs = res;
          this.loading = false;
        },
        error: (err) => {
          this.toastBarService.showToastError(
            'Something went wrong while getting the audit logs!'
          );
          console.error(
            'Something went wrong while getting the audit logs!',
            err
          );
        },
      });
  }

  stringifyData(jsonString: string) {
    let json = JSON.parse(jsonString);
    return JSON.stringify(json, undefined, 2);
  }
}
